import type { FinancialReportResponse, FinancialReportType } from "../api/types";
import liveResponses from "./liveReportResponses.json";

const KINDS: Record<FinancialReportType, FinancialReportResponse["kind"]> = {
  detail: "common", diagnosis: "common", decision: "common", "capital-chain": "common", "industry-gap": "common",
  dressing: "dressing", "account-movement": "account-movement", "industry-benchmark": "industry-comparison",
};

const NOTICE = "供应方真实接口返回，使用华远智能制造有限公司2021—2023年三期财务数据生成。";
const response = (type: FinancialReportType): FinancialReportResponse => ({
  ...liveResponses[type], kind: KINDS[type], reportType: type, sampleBasis: "embedded-real", sampleNotice: NOTICE,
}) as unknown as FinancialReportResponse;

export const COMMON_SAMPLE_AVAILABILITY = {
  detail: "live response", diagnosis: "live response", decision: "live response", "capital-chain": "live response", "industry-gap": "live response",
} as const;

export const mockReportResponses = Object.fromEntries(
  (Object.keys(KINDS) as FinancialReportType[]).map((type) => [type, response(type)]),
) as Record<FinancialReportType, FinancialReportResponse>;
